import React, { useState, useEffect } from "react";
import { Grid, ButtonGroup, Button, CircularProgress } from "@material-ui/core";
import "./styles/style.css";

import TableEnvios from "../components/Tables/TableEnvio/TableEnvio";
// import TableCancelaciones from "../../components/Tables/TableCancelaciones/TableCancelaciones";
// import TableRecolecciones from "../../components/Tables/TableRecolecciones/TableRecolecciones";
import useStyles from "./styles/stylesEnvios";
import useEnviosAPI from "../hooks/useEnviosAPI";

const EnviosDashboard = () => {
  const [currentTable, setCurrentTable] = useState("envios");
  const classes = useStyles();

  const [{ data, isLoading }, doFetch] = useEnviosAPI("");
  // console.log(data)
  useEffect(() => {
    doFetch();
  }, [doFetch]);
  // console.log(data)
  return isLoading || Object.keys(data).length === 0 ? (
    <CircularProgress />
  ) : (
    <Grid container spacing={2}>
      <ButtonGroup
        className={classes.buttonG}
        color="secondary"
        size="large"
        variant="contained"
      >
        <Button
          className={currentTable === "envios" ? classes.selected : ""}
          onClick={() => setCurrentTable("envios")}
        >
          Envios
        </Button>
        {/* <Button
          className={currentTable === "cancelaciones" ? classes.selected : ""}
          onClick={() => setCurrentTable("cancelaciones")}
        >
          Cancelaciones
        </Button>
        <Button
          className={currentTable === "recolecciones" ? classes.selected : ""}
          onClick={() => setCurrentTable("recolecciones")}
        >
          Recolecciones
        </Button> */}
      </ButtonGroup>
      {currentTable === "envios" && <TableEnvios data={data.data} />}
      {/* {currentTable === "cancelaciones" && (
        <TableCancelaciones data={data.tableCancelaciones} />
      )}
      {currentTable === "recolecciones" && (
        <TableRecolecciones data={data.tableRecolecciones} />
      )} */}
    </Grid>
  );
};

export default EnviosDashboard;
